import { createStyles } from "antd-style";
import { useBreakpoint } from "@/base/utils/index";
import { drawerPrefixCls } from "@/base/index";

export const useStyles = createStyles(({ css }: any) => ({
  drawer: css`
    .${drawerPrefixCls}-body {
      padding-inline: 0 !important;
    }
  `,
}));

export const useModalHeaderMenuStyles = () => {
  const screens = useBreakpoint();
  const styles = useStyles(screens);

  return styles;
};
